import React from 'react';

interface StatTileProps {
  label: string;
  value: number | string;
  /** Share of the total, shown next to the value. */
  percent?: number;
  color?: string;
}

const StatTile = ({ label, value, percent, color }: StatTileProps) => (
  <div className="bg-secondaryBlack rounded-2xl p-5 flex flex-col gap-1 min-w-0">
    <span className="flex items-center gap-2 text-textGray text-sm">
      {color && (
        <span
          className="inline-block w-2.5 h-2.5 rounded-sm flex-shrink-0"
          style={{ backgroundColor: color }}
        />
      )}
      {label}
    </span>
    <span className="flex items-baseline gap-2">
      <span className="text-mainWhite text-3xl font-semibold">{value}</span>
      {percent !== undefined && (
        <span className="text-textGray text-lg font-semibold">{percent}%</span>
      )}
    </span>
  </div>
);

export default StatTile;
